import React from 'react';
import { TouchableOpacity } from 'react-native';
import { Icon } from '@ant-design/react-native';
import { colorPalette } from '@shared/config/colorsConfig';
import { CHAT_COMPOSER_ICON_SIZE } from '../../constants';
import type { TChatAttachButtonProps } from '../../types';

export const ChatAttachButton = ({ disabled, label, onPress }: TChatAttachButtonProps) => (
    <TouchableOpacity
        onPress={onPress}
        disabled={disabled}
        accessibilityRole="button"
        accessibilityLabel={label}
        className="absolute right-2 bottom-2 w-8 h-8 items-center justify-center z-10"
    >
        <Icon
            name="paper-clip"
            size={CHAT_COMPOSER_ICON_SIZE}
            color={disabled ? colorPalette.gray[400] : colorPalette.gray[500]}
        />
    </TouchableOpacity>
);
